function render( cost?: number | null ) {
	if ( cost === undefined || cost === null ) {
		return ''
	}

	return `$${cost.toFixed( 2 )}`
}

export default {
	field: 'cost',
	name: 'Cost',
	width: '85px',
	render,
}
